export default __webpack_public_path__ + "static/media/veqtor_audifonos.a174a335.svg";